import React from "react";
import '../styles/ContactMe.css';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLinkedin, faGithub, faTwitter, faMedium } from "@fortawesome/free-brands-svg-icons";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";

import my_cv from '../../utils/Sourabh_CV.pdf';


class ContactMe extends React.Component {

    state = {
        copySuccess: false
    };

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    };

    copyToClipboard = (text) => {
        navigator.clipboard.writeText(text).then(() => {
            this.setState({ copySuccess: true });
            setTimeout(() => this.setState({ copySuccess: false }), 500);
        }).catch((err) => {
            console.error('Failed to copy text: ', err);
        });
    }

    render() {
        const { contactMe, links } = this.props;

        return (
            <div className="contact-div">
                <div className="sub-title-div">
                    <p className="tc">Contact Me!</p>
                </div>
                <div className="contact-description tc">
                    <p> I'd love to hear from you. Please contact me via email or phone. </p>
                </div>

                <div className="contact-info">
                    <div className="contact">
                        <p><a href={'mailto:' + contactMe.email}>{contactMe.email}</a></p>
                        <p className="animate-grow" onClick={() => this.copyToClipboard(contactMe.phone)} style={{ cursor: 'pointer', marginLeft: '10px' }} > {contactMe.phone}
                            {this.state.copySuccess && <span className="copy-success">Copied!</span>} </p>
                    </div>
                    <div className="social-profile">
                        <a className="animate-grow" href={links.linkedin} target="_blank">
                            <FontAwesomeIcon className="profile-icons " icon={faLinkedin} />
                        </a>
                        <a className="animate-grow" href={links.github} target="_blank">
                            <FontAwesomeIcon className="profile-icons " icon={faGithub} />
                        </a>
                        <a className="animate-grow" href={links.twitter} target="_blank">
                            <FontAwesomeIcon className="profile-icons " icon={faTwitter} />
                        </a>
                        <a className="animate-grow" href={links.medium} target="_blank">
                            <FontAwesomeIcon className="profile-icons " icon={faMedium} />
                        </a>
                        <a className="animate-grow" href={my_cv} target="_blank" download={'Sourabh_CV'}>
                            <FontAwesomeIcon className="profile-icons " icon={faFilePdf} />
                        </a>
                    </div>
                </div>

                <footer>
                    <p>© 2024 Sourabh Agrawal. All rights reserved.</p>
                </footer>
            </div>
        );
    }
}

export default ContactMe;